import styled from 'styled-components'
import { Form, Input, message } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { CommonProps } from '.'
import { FormInstance } from 'antd/es/form'
import { BlockButton } from './direct-login'
import { useState } from 'react'
import { setFixPassword } from './util'
import { t } from '@/i18n'
const { useForm } = Form
interface FirstResetProps extends CommonProps {}
export const FirstReset = props => {
  const formRef = React.createRef<FormInstance>()
  const [form] = useForm()
  const { setLoginStatus, oldpassword } = props
  const [fixPassword, fixPasswordLoading] = setFixPassword()
  const [pwd, setPwd] = useState('')
  const toDirectLogin = () => {
    if (localStorage.getItem('active') == '1') {
      setLoginStatus('direct-login')
    } else {
      setLoginStatus('sub-account')
    }
  }
  const onFinish = value => {
    fixPassword({
      old_password: oldpassword,
      new_password: value.rePwd,
    })
      .then(res => {
        if (res?.data?.code === '0') {
          message.success(t('密码重置成功，请重新登录'))
          toDirectLogin()
        } else if (localStorage.getItem('active') === '2' && res?.code === 200) {
          message.success(t('密码重置成功，请重新登录'))
          toDirectLogin()
        }
      })
      .catch(_ => {})
  }
  return (
    <Content>
      <Form form={form} ref={formRef} onFinish={onFinish}>
        <Form.Item
          name="pwd"
          rules={[
            { required: true, message: ' ' },
            () => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(t('请输入新密码'))
                }
                const regexList = [
                  /[A-Z]/, // 大写字母
                  /[a-z]/, // 小写字母
                  /[0-9]/, // 数字
                  /[·~!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, // 特殊字符
                ]

                let complexityCount = 0
                for (let i = 0; i < regexList.length; i++) {
                  if (regexList[i].test(value)) {
                    complexityCount++
                  }
                }
                if (value.length < 8 || complexityCount < 3) {
                  return Promise.reject(
                    t(
                      '密码长度最低为8位，必须包含以下至少三种字符: 大写字母、小写字母、特殊字符或数字组合',
                    ),
                  )
                }
                return Promise.resolve()
              },
            }),
          ]}
        >
          <Input.Password
            placeholder={t('请输入新密码')}
            prefix={<UserOutlined style={{ color: '#333333' }} />}
            maxLength={120}
            onChange={e => {
              setPwd(e.target.value)
              form.resetFields(['rePwd'])
            }}
          />
        </Form.Item>
        <Form.Item
          name="rePwd"
          rules={[
            { required: true, message: ' ' },
            () => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(t('请再次输入新密码'))
                }
                if (value !== pwd) {
                  return Promise.reject(new Error(t('两次密码输入不一致')))
                } else {
                  return Promise.resolve()
                }
              },
              dependencies: [pwd],
            }),
          ]}
        >
          <Input.Password
            placeholder={t('请再次输入新密码')}
            prefix={<UserOutlined style={{ color: '#333333' }} />}
            maxLength={120}
          />
        </Form.Item>
        <BlockButton
          block
          className="loginBtn"
          loading={fixPasswordLoading}
          type={'primary'}
          onClick={form.submit}
        >
          {t('确定')}
        </BlockButton>
      </Form>
    </Content>
  )
}

const Content = styled.div`
  .ant-btn-primary {
    background: #4238c9;
  }
  .ant-input-affix-wrapper,
  .ant-input {
    border-color: #d9d9d9;
    &:hover {
      border-color: #4238c9;
    }
  }
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
  }
  .send {
    height: 38px;
    color: #fff;
    background: #4238c9;
    border: 1px solid #4238c9;
    &:hover {
      background: linear-gradient(320deg, #4238c9 0%, #675fd3 100%);
      border: none;
    }
  }
`
